import React from 'react';
import ReportListContainer from '../../containers/report/ReportListContainer';

const ReportListPage = () => <ReportListContainer />;

export default ReportListPage;
